module.exports = __webpack_public_path__ + "img/hhc_eisai.b5ad7a50.jpg";